import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Typography,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';

import data from './data'

const Calculators = ({ trackingParam }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3" data-component="Calculators">
      <Typography variant="h2">Garden Project Calculators</Typography>
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3 sui-gap-4">
        {data.map(({ title, description, imageUrl, link }) => (
          <Card key={`${title}`}>
            <CardMedia src={imageUrl} alt={title} aspect="wide" />
            <CardTitle header={title} />
            <CardBody>
              <Typography>{description}</Typography>
            </CardBody>
            <CardActions>
              <Button variant="text" href={`${link}${trackingParam}`}>Learn More</Button>
            </CardActions>
          </Card>
        ))}
      </div>
    </div>
  )
}

Calculators.propTypes = {
  trackingParam: PropTypes.string,
}

Calculators.defaultProps = {
  trackingParam: '',
}

Calculators.displayName = 'Calculators'

export default Calculators
